/** What waits to send (lib/outbox.tsx): "2 waiting to send" with Send now, and anything the server refused, with why. */
import { useApiMaybe } from "../session.tsx";
import { useOutbox } from "../lib/outbox.tsx";
import { Icon } from "./Icons.tsx";
import { Button } from "./ui.tsx";

export function OutboxBanner() {
  const box = useOutbox(useApiMaybe());
  if (!box.pending.length && !box.failed.length) return null;
  const n = box.pending.length;
  return (
    <div className="offline outbox" role="status">
      {n > 0 && (
        <p><Icon name="clock" />{n === 1 ? "1 thing waits" : `${n} things wait`} to send: {box.pending.map((j) => j.label).join(", ")}. Saved on this device.
          {" "}<Button small variant="secondary" onClick={() => void box.flush()}>Send now</Button></p>
      )}
      {box.failed.map((j) => (
        <p key={j.id}><Icon name="alert" />Couldn't send {j.label}: {j.lastError}{" "}<Button small variant="quiet" onClick={() => box.dismiss(j.id)}>Clear this</Button></p>
      ))}
    </div>
  );
}
